export const getMonthsShort = (t: (key: string) => string) => [
    t("common.january.short"),
    t("common.february.short"),
    t("common.march.short"),
    t("common.april.short"),
    t("common.may.short"),
    t("common.june.short"),
    t("common.july.short"),
    t("common.august.short"),
    t("common.september.short"),
    t("common.october.short"),
    t("common.november.short"),
    t("common.december.short"),
];

export const getMonths = (t: (key: string) => string) => [
    t("common.january"),
    t("common.february"),
    t("common.march"),
    t("common.april"),
    t("common.may"),
    t("common.june"),
    t("common.july"),
    t("common.august"),
    t("common.september"),
    t("common.october"),
    t("common.november"),
    t("common.december"),
];

export const setStartDayHours = (date: Date | string | number) => new Date(new Date(date).setHours(0, 0, 0, 0));

export const setEndDayHours = (date: Date | string | number) => new Date(new Date(date).setHours(23, 59, 59, 999));

/**
 * Returns local midnight of the day AFTER `date`.
 *
 * Use this as the EXCLUSIVE upper bound of a day-range filter: passing a selected
 * end date through this makes the query include the full end day, expressed in the
 * browser's timezone (which we assume matches the car wash's timezone). This avoids
 * relying on the server to "round up" a 23:59 timestamp, which it can only do in its
 * own timezone.
 */
export const setStartOfNextDay = (date: Date | string | number) => {
    const d = new Date(new Date(date).setHours(0, 0, 0, 0));
    d.setDate(d.getDate() + 1);
    return d;
};

export const getWeekDays = (t: (key: string) => string) => [
    t("common.monday"),
    t("common.tuesday"),
    t("common.wednesday"),
    t("common.thursday"),
    t("common.friday"),
    t("common.saturday"),
    t("common.sunday"),
];
